import { render, staticRenderFns } from "./ListDocumentos.vue?vue&type=template&id=27d1fce4&"
import script from "./ListDocumentos.vue?vue&type=script&lang=js&"
export * from "./ListDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports